function getSharedWishlistPublicUrl(wishlistLid: string) {
  if (!wishlistLid) return null
  return `${process.env.NEXT_PUBLIC_VERCEL_URL}/wishlist/${wishlistLid}`
}

export default getSharedWishlistPublicUrl